import css from './PopupText.module.scss'

type MarkerTextProps = {
  children: React.ReactChild | string
}

export const PopupText = ({ children }: MarkerTextProps) => {
  return <div className={css.markerPopUp}>{children}</div>
}
